import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PilotPayHttpClient } from 'app/core';
import * as moment from 'moment';
import { IDiem, ITimeSheet, ITimeSheetHistory, ITransaction, ITrip } from './time-sheets.type';

@Injectable({
	providedIn: 'root'
})
export class TimeSheetService {
	constructor(private http: PilotPayHttpClient) {}

	public getTimeSheets(employeeId: number): Observable<ITimeSheet[]> {
		return this.http.getRequest(`/api/time-sheets/${employeeId}`);
	}

	public getPayPeriods(): Observable<any> {
		return this.http.getRequest('/api/time-sheets/pay-periods');
	}

	public getCurrentTimeSheet(employeeId: number, date: string): Observable<ITimeSheet> {
		return this.http.getRequest(`/api/time-sheets/employees/${employeeId}?date=${date}`);
	}

	public approveTrip(tripId: number, tripStatus: boolean): Observable<ITimeSheet> {
		return this.http.putRequest<ITimeSheet>(`/api/time-sheets/trip/${tripId}/${tripStatus}`, {});
	}

	public createTrip(payload: ITrip): Observable<ITimeSheet> {
		this.normalizeDateToUtc(payload, 'tripStart');
		this.normalizeDateToUtc(payload, 'tripEnd');
		return this.http.postRequest<ITimeSheet>(`/api/time-sheets/trip`, payload);
	}

	public deleteTrip(tripId: number): Observable<ITimeSheet> {
		return this.http.deleteRequest<ITimeSheet>(`/api/time-sheets/trip/${tripId}`);
	}

	public updateTrip(tripId: number, payload: ITrip): Observable<ITimeSheet> {
		this.normalizeDateToUtc(payload, 'tripStart');
		this.normalizeDateToUtc(payload, 'tripEnd');
		return this.http.putRequest<ITimeSheet>(`/api/time-sheets/trip/${tripId}`, payload);
	}

	public addPerDiem(payload: IDiem): Observable<ITimeSheet> {
		this.normalizeDateToUtc(payload, 'perDiemStart');
		this.normalizeDateToUtc(payload, 'perDiemEnd');
		return this.http.postRequest<ITimeSheet>(`/api/time-sheets/per-diem`, payload);
	}

	public deletePerDiem(perDiemId: number): Observable<ITimeSheet> {
		return this.http.deleteRequest<ITimeSheet>(`/api/time-sheets/per-diem/${perDiemId}`);
	}

	public updatePerDiem(payload: IDiem): Observable<ITimeSheet> {
		this.normalizeDateToUtc(payload, 'perDiemStart');
		this.normalizeDateToUtc(payload, 'perDiemEnd');
		return this.http.putRequest<ITimeSheet>(`/api/time-sheets/per-diem/${payload.timeSheetPerDiemId}`, payload);
	}

	public addTransaction(payLoad: ITransaction): Observable<ITimeSheet> {
		return this.http.postRequest<ITimeSheet>(`/api/time-sheets/transaction`, payLoad);
	}

	public deleteTransaction(perDiemId: number): Observable<ITimeSheet> {
		return this.http.deleteRequest<ITimeSheet>(`/api/time-sheets/transaction/${perDiemId}`);
	}

	public updateTransaction(payload: ITransaction): Observable<ITimeSheet> {
		return this.http.putRequest<ITimeSheet>(
			`/api/time-sheets/transaction/${payload.timeSheetTransactionId}`,
			payload
		);
	}

	public normalizeDateToUtc(payload: any, field: string): void {
		//Forcing the calander to use UTC timezone instead of default device timezone
		payload[field] = moment(payload[field])
			.utc(true)
			.format('YYYY-MM-DDTHH:mm:ss');
	}

	public submitTimeSheet(timeSheetId: number, timeSheetStatus: number): Observable<ITimeSheet> {
		return this.http.putRequest<ITimeSheet>(`/api/time-sheets/${timeSheetId}/${timeSheetStatus}`, null);
	}

	public getTimeSheetTransactionNoteValues(noteSettingsId: number): Observable<string[]> {
		return this.http.getRequest(`/api/time-sheets/transaction-notes/${noteSettingsId}`);
	}

	public getTransactionHistory(transactionId: number): Observable<ITimeSheetHistory[]> {
		return this.http.getRequest(`/api/time-sheets/transaction/${transactionId}/history`);
	}

	public getTripHistory(tripId: number): Observable<ITimeSheetHistory[]> {
		return this.http.getRequest(`/api/time-sheets/trip/${tripId}/history`);
	}
}
